import { Outlet, useParams } from "react-router-dom";

import "./Report.scss";
import useTitle from "../../../Components/Hooks/useTitle";

export default function Report(props) {
  let id = useParams()["id"];
  useTitle("گزارش")

  return (
    <div className="report-page">
      <Outlet context={id} />
    </div>
  );
}
